export type RecordingHit = {
  name: string;
  display_name: string;
  startTime?: number;
  endTime?: number;
};

export type RecordingReference = {
  name: string;
  startTime?: number;
  endTime?: number;
};

export const getRecordingLabel = (recording: RecordingHit): string =>
  recording.display_name || recording.name;

export const getRecordingKey = (recording: RecordingHit): string => {
  if (recording.startTime === undefined && recording.endTime === undefined) {
    return recording.name;
  }
  return `${recording.name}#${recording.startTime ?? ''}-${recording.endTime ?? ''}`;
};
